import React from 'react';

interface PadlockIconProps extends React.SVGProps<SVGSVGElement> {
    isUnlocked: boolean;
    color: string;
}

export const PadlockIcon: React.FC<PadlockIconProps> = ({
    isUnlocked,
    className,
    color,
    ...props
}) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
            className={className}
            {...props}
        >
            <rect
                x="3"
                y="11"
                width="18"
                height="11"
                rx="2"
                ry="2"
                fill={color}
                stroke="none"
            />
            <path
                d={
                    isUnlocked
                        ? 'M7 11V7a5 5 0 0 1 9.9-1'
                        : 'M7 11V7a5 5 0 0 1 10 0v4'
                }
                stroke={color}
                strokeWidth="3"
                fill="none"
            />
            {/* Keyhole */}
            <circle cx="12" cy="15.5" r="1.5" fill="white" />
            <path d="M12 17 L11 20 L13 20 Z" fill="white" />
        </svg>
    );
};

